import {
  fetchCreditorBalanceStatement,
  fetchCreditorBalanceStatementExport,
  fetchCreditorBalanceSummary,
  fetchCreditorBalanceSummaryExport,
} from '@views/suppliersBalance/query-api'
import { normalizeLedgerEntry } from '@views/suppliersBalance/utils/normalizeCreditorBalanceStatement'
import { normalizeCreditorBalanceContact } from '@views/suppliersBalance/utils/normalizeCreditorBalanceSummary'

import { NotificationKeys } from '../../../enums/notificationKeys'
import { QueryKeys } from '../../../enums/queryKeys'
import { TableIds } from '../../../enums/tableIds'
import { BalanceFilterType } from '../enums/balanceFilterType'
import { BalanceSide } from '../enums/balanceSide'
import { BalanceSortProperty } from '../enums/balanceSortProperty'
import { LEDGER_ENTRY_SORT_BY } from '../enums/ledgerEntryColumn'
import type { BalanceSideConfig } from './balanceSideConfig'

// See the TEMPORARY dependency note in `balanceSideConfig.ts` for why this imports from
// `@views/suppliersBalance`.
export const supplierBalanceConfig: BalanceSideConfig = {
  side: BalanceSide.Supplier,
  i18nPrefix: 'suppliers_balance',
  trackingObject: 'Supplier Balance',

  getMainRoute: () => 'expert/suppliers-balance',
  getDetailRoute: (id = ':id') => `expert/suppliers-balance/${id}`,
  filtersUrlQueryKey: 'suppliersBalanceFilters',
  tableId: TableIds.SuppliersBalance,
  defaultPageSize: 25,

  filterTypeOrder: [BalanceFilterType.Account, BalanceFilterType.BalanceDirection],
  filterTypeMeta: {
    [BalanceFilterType.Account]: { labelKey: 'suppliers_balance.filters.account.label', icon: 'store' },
    [BalanceFilterType.BalanceDirection]: {
      labelKey: 'suppliers_balance.filters.balance_direction.label',
      icon: 'arrowRightLeft',
    },
  },
  defaultSortBy: BalanceSortProperty.AccountNumber,
  ledgerSortByMap: LEDGER_ENTRY_SORT_BY,

  querySummaryKey: QueryKeys.CreditorBalanceSummary,
  queryStatementKey: QueryKeys.CreditorBalanceStatement,
  querySummaryAccountsKey: QueryKeys.CreditorBalanceSummaryAccounts,

  exportNotificationKey: NotificationKeys.SuppliersBalanceExport,

  fetchSummary: fetchCreditorBalanceSummary,
  fetchStatement: fetchCreditorBalanceStatement,
  // There is no dedicated "accounts" endpoint — the accounts list is derived from the summary
  // response, mirroring `views/suppliersBalance/hooks/useFetchCreditorBalanceSummaryAccounts.ts`.
  fetchSummaryAccounts: fetchCreditorBalanceSummary,
  fetchSummaryExport: fetchCreditorBalanceSummaryExport,
  fetchStatementExport: fetchCreditorBalanceStatementExport,
  normalizeSummaryContact: normalizeCreditorBalanceContact,
  normalizeStatementEntry: normalizeLedgerEntry,
}
